import { widgetRegistry } from '../../../core/widgets/WidgetRegistry';
import { InventoryStatsWidget } from './InventoryStatsWidget';

export function registerInventarWidgets() {
  widgetRegistry.register({
    id: 'inventory-stats',
    title: 'Inventar',
    description: 'Gerätebestand und Gesamtkaufwert auf einen Blick',
    component: InventoryStatsWidget,
    category: 'inventar',
    requiredPermission: 'technik.inventory',
    defaultSize: 'full',
    defaultEnabled: false,
    order: 50,
  });
}
